import React from 'react';

const DualSelectItem = (props) => {
    const {item, handleItemSelect, selectedItems, source} = props;
    return (
        <div className={'dual-select-item ' + (selectedItems.indexOf(item) > -1 ? 'dual-select-item--selected' : '')}
             onClick={() => handleItemSelect(item, source)}>
            {item.group ?
                <i className="icon-placeholder fa fa-list"/>
                :
                <i className="icon-placeholder"/>
            }
            {item.name}
            {item.group &&
            <>
                 &nbsp; <span className="badge badge-pill badge-secondary">{item.items.length}</span>
            </>
            }
        </div>
    );
};

export default DualSelectItem;
